<div class="row mb-2 pt-5">
  <div class="mx-2">
    <div class="d-flex">

      <div class="position-relative" *ngIf="candidateDocuments?.length > 0">

        <select data-testid="auto-app-person-search-document-slider-select-1" class="nobg wc-form-control position-relative" [(ngModel)]="selectedDocument"
          (change)="onDocumentChange($event)">
          <!-- <option *ngFor="let doc of candidateDocuments" [value]="doc.url">{{ doc.filename }}</option> -->
          <option *ngFor="let doc of candidateDocuments" [value]="doc.url">
            {{ getFileName(doc.filename) }}
          </option>
        </select>
      </div>
      <div class="ml-2 mt-1" style="color: #2E93A1;">
        <span (click)="downloadDocument()" class="pointer"><i class="fa-solid fa-download"></i></span>
      </div>
    </div>
  </div>
</div>
<div class="row position-relative">
  <div class="col position-relative resume-on-newtab" *ngIf="downloadpreviewresumeurl">


    <pdf-viewer [src]="downloadpreviewresumeurl" *ngIf="downloadpreviewresumeurl" [render-text]="true" [original-size]="true"
      frameborder="0" type="application/pdf" allowfullscreen class="doc-iframe-div">
    </pdf-viewer>

  </div>
</div>